import { InvalidGalleryContentError } from '../errors/InvalidGalleryContentError';

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export interface AlbumInput {
  id: string;
  title: string;
  slug: string;
  coverImage: string;
}

export class Album {
  private constructor(public readonly props: AlbumInput) {
    Object.freeze(this.props);
    Object.freeze(this);
  }

  public static create(input: AlbumInput): Album {
    const title = input.title.trim();
    const slug = input.slug.trim();

    if (title.length === 0) {
      throw new InvalidGalleryContentError('album title must not be empty.');
    }
    if (!SLUG_PATTERN.test(slug)) {
      throw new InvalidGalleryContentError(`album slug "${slug}" must be lowercase kebab-case.`);
    }
    if (input.coverImage.trim().length === 0) {
      throw new InvalidGalleryContentError('album coverImage must not be empty.');
    }

    return new Album({ ...input, title, slug });
  }
}
